import React from 'react';

// CDN URLs for data source icons
export const DATA_SOURCE_ICONS = {
  google_sheets: 'https://d2atdwxjx7uc4i.cloudfront.net/images/google-sheets.svg',
  microsoft_excel: 'https://d2atdwxjx7uc4i.cloudfront.net/images/microsoft_excel.svg',
  airtable: 'https://d2atdwxjx7uc4i.cloudfront.net/images/airtable-icon.svg'
};

// Brand colors for data source buttons
export const DATA_SOURCE_COLORS = {
  microsoft_excel: '#217346',
  airtable: '#18BFFF'
};

// Get icon element for a data source type
export const getDataSourceIcon = (sourceType, options = {}) => {
  const { height = '20px', marginRight = '8px' } = options;

  if (sourceType === 'google_sheets') {
    return (
      <img
        src={DATA_SOURCE_ICONS.google_sheets}
        alt="Google Sheets"
        style={{ height, marginRight }}
      />
    );
  } else if (sourceType === 'microsoft_excel') {
    return (
      <img
        src={DATA_SOURCE_ICONS.microsoft_excel}
        alt="Microsoft Excel"
        style={{ height, marginRight }}
      />
    );
  } else if (sourceType === 'airtable') {
    return (
      <img
        src={DATA_SOURCE_ICONS.airtable}
        alt="Airtable"
        style={{ height, marginRight }}
      />
    );
  }
  return null;
};

// Connect buttons for data sources (used in settings page and data source picker)
// Google Sheets and Airtable logos include their names, Excel icon needs text label
export const DataSourceConnectButtons = ({
  onConnectGoogleSheets,
  onConnectMicrosoftExcel,
  onConnectAirtable
}) => {
  const buttonStyle = { display: 'flex', alignItems: 'center', padding: '8px 16px' };

  return (
    <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
      <button
        type="button"
        className="btn btn-default"
        onClick={onConnectGoogleSheets}
        style={buttonStyle}
      >
        <img
          src={DATA_SOURCE_ICONS.google_sheets}
          alt="Google Sheets"
          style={{ height: '24px' }}
        />
      </button>
      <button
        type="button"
        className="btn btn-default"
        onClick={onConnectMicrosoftExcel}
        style={buttonStyle}
      >
        <img
          src={DATA_SOURCE_ICONS.microsoft_excel}
          alt="Microsoft Excel"
          style={{ height: '24px', marginRight: '8px' }}
        />
        {t('quote_builder.microsoft_excel')}
      </button>
      <button
        type="button"
        className="btn btn-default"
        onClick={onConnectAirtable}
        style={{
          ...buttonStyle,
          backgroundColor: DATA_SOURCE_COLORS.airtable,
          borderColor: DATA_SOURCE_COLORS.airtable,
          color: '#fff'
        }}
      >
        <img
          src={DATA_SOURCE_ICONS.airtable}
          alt="Airtable"
          style={{ height: '20px', filter: 'brightness(0) invert(1)' }}
        />
      </button>
    </div>
  );
};
